import { useTranslations } from 'next-intl';
import TimeSlot from './TimeSlot';
import useCountdown from '@/src/utils/useCountdown';
import { PiConfetti } from 'react-icons/pi';
import './AuctionTimer.css';

export default function AuctionTimer({ end }: { end: string | number | Date }) {
  const t = useTranslations('AuctionTimer');
  const countDown = useCountdown(end);

  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  const minutesToEnding = process.env.NEXT_PUBLIC_TIME_EXTEND
    ? Number(process.env.NEXT_PUBLIC_TIME_EXTEND)
    : 2;

  // Check if countdown is in the last minutes before ending
  const closeToEnding =
    countDown > 0 && days === 0 && hours === 0 && minutes < minutesToEnding
      ? true
      : false;

  return (
    <div className='flex justify-center gap-6 border-t-b border-dark p-6 pb-0 uppercase'>
      <ul
        className={`m-auto flex flex-wrap items-center gap-2 xl:gap-4 ${
          closeToEnding ? 'warning font-bold' : ''
        }`}
      >
        {countDown > 0 && (
          <>
            <TimeSlot label={t('days')} counter={days} />
            <li className='text-2xl'>:</li>
            <TimeSlot label={t('hours')} counter={hours} />
            <li className='text-2xl'>:</li>
            <TimeSlot label={t('min')} counter={minutes} />
            <li className='text-2xl'>:</li>
            <TimeSlot label={t('sec')} counter={seconds} />
          </>
        )}
        {countDown <= 0 && (
          <div className='my-4 flex items-center gap-2 rounded-lg bg-brand-alt px-4 py-2 text-center text-xl font-semibold text-white'>
            {t('ended')}
            <span className='text-3xl'>
              <PiConfetti />
            </span>
          </div>
        )}
      </ul>
    </div>
  );
}
